<template>
  <div class="wechat">
    <Back/>
    <div class="wechat__logo">
      <SvgIcon icon-class="wechat" width="40" height="40"/>
      {{$t('wechat.name')}}
    </div>
    <div class="wechat__title">
      {{$t('wechat.subscription')}}
    </div>
    <div class="wechat__qrcode">
      <img :src="dataUrl" alt="" width="250px" height="250px">
    </div>
    <div class="wechat__amount">
      {{$t('wechat.amountToPay')}} {{symbol}} {{amount|currency}}
    </div>
  </div>
</template>

<script>
import qrcode from 'qrcode'
import { queryPay } from '@/api'
import { wechatScreen } from '@/utils/screen'
import { getSymbol, fen2yuan } from '@/utils/currency'
import { get } from 'lodash-es'
import { types } from '@hll/cashier-kit'
import { mapGetters } from 'vuex'

export default {
  name: 'Wechat',
  props: {
    payUrl: {
      type: String
    },
    payToken: {
      type: String
    }
  },
  data () {
    return {
      dataUrl: '',
      timer: null
    }
  },
  mounted () {
    wechatScreen()
  },
  methods: {
    startLoop () {
      if (this.timer) {
        return
      }
      this.timer = setInterval(() => {
        queryPay({ payToken: this.payToken }).then(res => {
          if (parseInt(res.data?.status) === 2) {
            clearInterval(this.timer)
            this.$emit('goTo', { component: 'Result', type: 'unknown' })
          }
        })
      }, 5000)
    },
    beforeDestroy () {
      clearInterval(this.timer)
    }
  },
  watch: {
    payUrl: {
      immediate: true,
      handler (val) {
        if (val) {
          qrcode.toDataURL(val, (err, url) => {
            if (err) return this.$Message.error('二维码加载失败')
            this.dataUrl = url
            this.startLoop()
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters([types.ORDER_INFO]),
    symbol () {
      return getSymbol(get(this[types.ORDER_INFO], 'orderInfo.hcurrency'))
    },
    amount () {
      return fen2yuan(get(this[types.ORDER_INFO], 'orderInfo.amount_fen'), 0)
    }
  }
}
</script>

<style scoped lang="scss">
.wechat {
  &__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-top: 48px;
  }
  &__title{
    text-align: center;
    font-size: 20px;
    margin-top: 48px;
  }
  &__qrcode{
    margin-top: 26px;
    display: flex;
    justify-content: center;
  }
  &__amount{
    font-size: 14px;
    text-align: center;
    margin-top: 26px;
  }
}
</style>
